import {
  IPriceProviderRow,
  IPriceSummaryModel,
} from "@/lib/interfaces and Enums/InterfacePriceSummary";
import { TNotation } from "@/lib/interfaces and Enums/TYPENotations";
import { create } from "zustand";

// LQC-2575 - rows are seeded from the bond reference data (GET /Securities/bonds) and
// then overwritten in place by live MegaPipe prices. The reference data can return a
// null price and carries no yields yet, so every price field is optional.
// id is what AG Grid's getRowId reads - it is always the ISIN.
export interface IPriceDataItem extends Partial<IPriceSummaryModel> {
  id?: string;
  isin: string;
  securityName: string;
  // Bond reference detail, used for row grouping and filtering.
  issuer?: string;
  currency?: string;
  maturityDate?: string;
  couponRate?: number | null;
  notation?: TNotation | null;
  priceDate?: string;
  providerPrices?: IPriceProviderRow[];
}

type State = {
  data: IPriceDataItem[];
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  setData: (incomingData: IPriceDataItem[]) => void;
  // eslint-disable-next-line no-unused-vars
  updateSinglePrice: (imcomingPirceData: IPriceSummaryModel) => void;
};

const priceDataStore = create<State & Action>((set) => ({
  data: [],
  setData: (incomingData) => set({ data: incomingData }),
  // Spread the existing row first - a live price carries no bond reference detail and
  // must not drop issuer / currency / maturity / providerPrices off the row.
  updateSinglePrice: (incomingPriceData) =>
    set((state) => ({
      data: state.data.map((price) =>
        price.isin == incomingPriceData.isin
          ? { ...price, ...incomingPriceData, id: price.isin }
          : price,
      ),
    })),
}));

export default priceDataStore;
